import { createFileRoute } from '@tanstack/react-router';
import { DocumentsPage } from '@/features/documents';

export const Route = createFileRoute('/_app/documents/folders/$folderId')({
  component: FolderPage,
});

function FolderPage() {
  const { folderId } = Route.useParams();
  return <DocumentsPage folderId={folderId} />;
}
